<template>
    <div>
        <h3 style="margin-right: 120px;width: 200px;"># 禁言列表</h3>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="全部列表" name="0"></el-tab-pane>
            <el-tab-pane label="禁言列表" name="1"></el-tab-pane>
            <el-tab-pane label="已解除禁言列表" name="2"></el-tab-pane>
        </el-tabs>
        <el-table :data="contentTableData" style="width: 100%">
            <!-- <el-table-column align="center" type="selection" width="55">
            </el-table-column> -->
            
            <el-table-column prop="userId" label="用户ID" width="100" align="center">
            </el-table-column>

            <el-table-column prop="nickName" label="用户昵称" width="150" align="center">
            </el-table-column>

            <el-table-column prop="userPicture" label="用户头像" width="100" align="center">
                <template slot-scope="scope">
                    <el-image :src="scope.row.userPicture" style="width: 40px;height: 40px;" fit="cover" :preview-src-list="[scope.row.userPicture]" />
                </template>
            </el-table-column>

            <el-table-column prop="banType" label="禁言类型" width="150" align="center">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.type == 1 ? 'danger' : ''">
                        {{ scope.row.type == 0 ? '圈子禁言' : '全域禁言' }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column prop="circleName" label="圈子昵称" width="120" align="center">
                <template slot-scope="scope">
                    {{ scope.row.circleName ? scope.row.circleName : '--' }}
                </template>
            </el-table-column>

            <el-table-column prop="circleId" label="圈子ID" width="100" align="center">
                <template slot-scope="scope">
                    {{ scope.row.circleId ? scope.row.circleId : '--' }}
                </template>
            </el-table-column>

            <el-table-column prop="circleId" label="禁言时长" width="100" align="center">
                <template slot-scope="scope">
                    {{ scope.row.unit == 0 ? scope.row.time + '分钟' : scope.row.unit == 1 ? scope.row.time + '小时' :
                        scope.row.unit == 2 ? scope.row.time + '天' : '' }}
                </template>
            </el-table-column>

            <el-table-column prop="createTime" label="禁言开始时间" width="160" align="center">
            </el-table-column>

            <el-table-column prop="liberatedTime" label="禁言截止时间" width="160" align="center">
            </el-table-column>

            <el-table-column prop="reason" label="禁言原因" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                    {{ scope.row.reason ? scope.row.reason : '未填写' }}
                </template>
            </el-table-column>

            <el-table-column label="操作" width="160" align="center">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" plain @click="handleDelete(scope.row)">
                        操作
                    </el-button>
                    <el-button size="mini" type="danger" :disabled="scope.row.isLiberated" plain @click="liftMuteFn(scope.row)">
                        解除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="block" style="text-align: right;margin-top: 10px;">
            <el-pagination @current-change="currenChange" :current-page="params.pageNum" layout="prev, pager, next"
                :total="total_pages">
            </el-pagination>
        </div>

        <el-dialog :visible.sync="addPlatformShow" width="400px" title="平台封禁" append-to-body>
            <banUserMute :muteCount="muteCount" v-if="addPlatformShow" @platSubmit="handelPlatFn"></banUserMute>
        </el-dialog>
    </div>
</template>

<script>
import { GetCreateMuteListApi, setMuteLiberatedApi, addBanUserApi } from '@/api/circle'
import { getMuteCountApi } from '@/api/superAdmin'
import banUserMute from '@/views/userManage/home/components/banUserMute.vue'
export default {
    name: 'conTent',
    components: {
        banUserMute
    },
    async created() {
        this.contentTableData = []
        if (this.circleId) {
            this.params.circleId = this.circleId
        }
        this.getDataFn()
    },
    props: {
        circleId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            contentTableData: [],
            total_pages: 1,
            addPlatformShow: false,
            activeName: '1',
            multipleSelection: [],
            selectContentStateData: '',
            selectInputData: '',
            pushData: false,
            params: {
                pageNum: 1,
                pageSize: 10,
                isLiberated: false
            },
            editUserform: { userid: '' },
            muteCount: 0,
        }
    },
    methods: {
        // 解除禁言
        liftMuteFn(rows) {
            this.$confirm('您确定要解除该用户禁言吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                return setMuteLiberatedApi(rows.id).then(res => {
                    if (res.code == 200 && res.data !== false) {
                        this.getDataFn();
                        this.$message({ type: 'success', message: '操作成功' });
                    } else {
                        this.$message({ type: 'error', message: res.msg });
                    }
                })
            }).catch(error => {
                if (error !== 'cancel' && error !== 'close') this.$message.error('解除禁言失败，请重试');
            });
            // 
        },
        // 封禁函数
        handelPlatFn(data) {
            const that = this;
            data.userId = that.editUserform.userId
            addBanUserApi(data).then(res => {
                that.addPlatformShow = false;
                if (res.code == 200) {
                    that.$message({ type: 'success', message: '操作成功' });
                    that.getDataFn();
                } else {
                    that.$message({ type: 'error', message: res.msg });
                }
            }).catch(err => {
                that.addPlatformShow = false;
            })
        },
        async getDataFn() {
            GetCreateMuteListApi(this.params).then(res => {
                if (res.code == 200) {
                    this.contentTableData = (res.data && res.data.records) || []
                    this.total_pages = (res.data && res.data.total) || 0
                } else {
                    this.$message.error(res.msg)
                }
            }).catch(() => {
                this.$message.error('数据获取失败, 请重试~')
            })
        },
        // 分页被单击
        async currenChange(pages) {
            this.params.pageNum = pages
            this.getDataFn()
        },
        // 切换导航栏
        async handleClick(tab, event) {
            console.log('tab, event', tab, event);
            this.params.pageNum = 1
            this.params.isLiberated = this.activeName === '0' ? undefined : this.activeName === '2'
            this.getDataFn()
        },
        handleDelete(rows) {
            this.editUserform = { ...rows }
            getMuteCountApi(this.editUserform.userId).then(res => {
                if (res.code == 200) {
                    this.muteCount = res.data
                } else {
                    this.$message.error(res.msg || '禁言总数获取失败, 请重试~')
                }
            }).catch((err) => {
                this.$message.error(err || '禁言总数获取失败, 请重试~')
            })
            this.addPlatformShow = true
        },
    }
}
</script>

<style></style>
